import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { AttachmentFile } from '../../../../core/domain/models';
import { AttachmentFileDto } from '../dtos/attachment-file.dto';
export var AttachmentFileApiMapper = /*#__PURE__*/function () {
  function AttachmentFileApiMapper() {
    _classCallCheck(this, AttachmentFileApiMapper);
  }

  _createClass(AttachmentFileApiMapper, [{
    key: "toDomain",
    value: function toDomain(dto) {
      return AttachmentFile.create({
        id: dto.id,
        fileName: dto.fileName,
        fileMimeType: dto.fileMimeType,
        url: dto.url,
        fileSize: dto.fileSize
      });
    }
  }, {
    key: "toDto",
    value: function toDto(domain) {
      var dto = new AttachmentFileDto();
      dto.id = domain.id;
      dto.fileName = domain.fileName;
      dto.fileMimeType = domain.fileMimeType;
      dto.url = domain.url;
      dto.fileSize = domain.fileSize;
      return dto;
    }
  }]);

  return AttachmentFileApiMapper;
}();